import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getEvents(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("events?" + parameters);
  return data;
}

export async function getEvent(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`events/${id}?${parameters}`);
  return data;
}

export async function createEvent(values) {
  const { data } = await axios.post("events", values);
  return data;
}

export async function updateEvent(id, values) {
  const { data } = await axios.patch("events/" + id, values);
  return data;
}

export async function deleteEvent(id) {
  const { data } = await axios.delete("events/" + id);
  return data;
}

export async function getEventProfiles(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("events/" + id + "/profiles?" + parameters);
  return data;
}

export async function generateAndSendAllVouchers(eventId) {
  const { data } = await axios.post(
    `/events/${eventId}/actions/generate-vouchers`,
    {
      sendVouchers: true
    }
  );
  return data;
}

export async function generateAllVouchers(eventId) {
  const { data } = await axios.post(
      `/events/${eventId}/actions/generate-vouchers`,
      {
        sendVouchers: false
      }
  );
  return data;
}
